export default __webpack_public_path__ + "static/media/director1.13237872.jpg";